import React from 'react';
import './CartItemPrice.less';
import {convertPrice} from "helpers/format.helper";


export const CartItemPrice = ({price}) => {
	return <span className="cart-item-price">{convertPrice(price)}</span>;
};
